import React, { useEffect, createElement, Component } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
    __mp_pixel_initialized?: boolean;
  }
}
const PIXEL_ID = '2820238711690534';
// ---------------------------------------------------------------------------
// Initialize at module-load time (NOT inside useEffect) so the Pixel fires as
// soon as the JS bundle executes — before React mounts. This guarantees that
// Meta Pixel Helper detects an active pixel + PageView + ViewContent even if a
// user bounces quickly, and that Meta Ads receives Landing Page Views reliably.
//
// A guard on `window.__mp_pixel_initialized` prevents double init from HMR,
// re-imports or Strict Mode re-renders.
// ---------------------------------------------------------------------------
if (typeof window !== 'undefined' && !window.__mp_pixel_initialized) {
  window.__mp_pixel_initialized = true;
  (function (f: any, b: Document, e: string, v: string) {
    let n: any, t: HTMLScriptElement, s: HTMLScriptElement | null;
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e) as HTMLScriptElement;
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0] as HTMLScriptElement;
    s?.parentNode?.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  // Initialize the pixel
  window.fbq('init', PIXEL_ID);
  // Standard PageView — fires automatically on every page load
  window.fbq('track', 'PageView');
  // ViewContent — fires automatically on the landing because this IS the
  // product page. Includes product metadata so Meta can attribute purchases
  // back to the correct campaign / catalog item.
  window.fbq('track', 'ViewContent', {
    content_name: 'Mega Pack Enfermería',
    content_category: 'Educación · Enfermería',
    content_ids: ['mega-pack-enfermeria'],
    content_type: 'product',
    value: 19990,
    currency: 'ARS'
  });
}
// ---------------------------------------------------------------------------
// Component — only renders the <noscript> fallback. All initialization happens
// at module load above. This component is included in App so the noscript img
// renders into the DOM for clients with JS disabled.
// ---------------------------------------------------------------------------
export function MetaPixel() {
  return <noscript data-id="element-220">
      <img height="1" width="1" style={{
      display: 'none'
    }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-221" />
    </noscript>;
}
// Helper used by checkout CTAs (PricingOptions / FinalCTA) to fire
// InitiateCheckout. Safe to call before the pixel has finished loading — the
// fbq queue keeps the event until the script is ready.
export function trackPixelEvent(event: string, params?: Record<string, any>) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', event, params);
  }
}